//普通对象转FormData格式
export const obj2formData = (param) => {
  let form_data = new FormData();
  for (let key in param) {
    form_data.append(key, param[key] === null ? '' : param[key]);
  }
  return form_data;
};

//判断是否是空对象
export const isEmpty = (obj) => {
  if (obj === null || obj === undefined || obj === '') {
    return true;
  }
  return Object.keys(obj).length === 0;
};

/*
格式化日期
*/
export function formateDate(time) {
  if (!time) return ''
  let date = new Date(time)
  return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
}

/**
 * 获得句子中有多少个单词
 */
export function countWords(sentence) {
  const words = sentence.split(/[\s,.?!]+/);
  const filteredwords = words.filter(word => word.length>0);
  return filteredwords.length;
}